'use client'
import React from 'react';

const GradientButton = ({ gradient = 'cyan-blue', text, className = '', onClick, zIndex = '' }) => {
    const gradientStyles = {
        'purple-blue': 'bg-purple-500/10 text-purple-400 border border-purple-500/20 hover:bg-purple-500/20',
        'cyan-blue': 'bg-sky-500/10 text-sky-400 border border-sky-500/20 hover:bg-sky-500/20',
        'green-blue': 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 hover:bg-emerald-500/20',
        'purple-pink': 'bg-fuchsia-500/10 text-fuchsia-400 border border-fuchsia-500/20 hover:bg-fuchsia-500/20',
        'pink-orange': 'bg-rose-500/10 text-rose-400 border border-rose-500/20 hover:bg-rose-500/20',
        'teal-lime': 'bg-teal-500/10 text-teal-400 border border-teal-500/20 hover:bg-teal-500/20',
        'red-yellow': 'bg-amber-500/10 text-amber-400 border border-amber-500/20 hover:bg-amber-500/20',
        'dark': 'bg-violet-500/10 text-violet-400 border border-violet-500/20 hover:bg-violet-500/20',
    }

    return (
        <button
            onClick={onClick}
            className={`
                px-6 py-3 rounded-lg font-medium
                transition-all duration-200
                backdrop-blur-xl
                ${gradientStyles[gradient]}
                ${zIndex}
                ${className}
            `}
        >
            {text}
        </button>
    )
}

export default GradientButton